import { IPerson } from '../../../services/person.service';
class EmployeeListController {

    private employees: IPerson[];
    
    constructor() {
        "ngInject";
    }
}

export const employeeListComponent = {
    bindings: {
        employees : "<"
    },
    controller : EmployeeListController,
    template : require("./employee.list.html")
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/employee/employee.list.component.ts